import * as React from 'react'
import { useIntl } from '@/intl'
import { useTrackFieldValidation } from '@/scopes/checkout/components/PersonalDetailsForm/useTrackFieldValidation'
import { TextInput } from '@/scopes/common/components/FormElements/TextInput'
import styles from '../Form.module.css'

export function SurnameInput({
  name,
  pattern,
  required,
}: {
  name: string
  pattern?: string
  required?: boolean
}) {
  const intl = useIntl()
  useTrackFieldValidation(name)

  return (
    <TextInput
      name={name}
      label={intl.formatMessage({ id: 'checkout_steps_participants_form_field_label_surname' })}
      required={required}
      requiredErrorMessage={intl.formatMessage({ id: 'checkout_steps_participants_form_field_required_error_message_surname' })}
      pattern={pattern}
      patternErrorMessage={
        intl.formatMessage({ id: 'checkout_steps_participants_form_field_pattern_error_message_surname' })
      }
      formFieldClass={styles.personalDetailsFormField}
      helpText={intl.formatMessageIfExists({ id: 'checkout_steps_participants_form_field_help_text_surname' })}
    />
  )
}
